module.exports = __webpack_public_path__ + "static/media/Arrow-Down.da736b5c.svg";